import { memo } from 'react';
import { PrimaryList } from '../../design-system';

interface OtherRequirementsPreviewProps {
  otherRequirements: string[];
  education: string[];
  certificates: string[];
  languages: Array<{ key: string; label: string; level: string }>;
}

export const OtherRequirementsPreview = memo(
  ({ otherRequirements, education, certificates, languages }: OtherRequirementsPreviewProps) => {
    const hasAnyRequirements =
      otherRequirements?.length > 0 || education?.length > 0 || certificates?.length > 0 || languages?.length > 0;

    if (!hasAnyRequirements) return null;

    const itemList = [
      ...(otherRequirements?.map((label) => ({
        key: label,
        label: label,
        icon: 'ClipboardDocumentCheckIcon' as const,
      })) || []),
      ...(education?.map((label) => ({
        key: label,
        label: label,
        icon: 'AcademicCapIcon' as const,
      })) || []),
      ...(certificates?.map((label) => ({
        key: label,
        label: label,
        icon: 'ClipboardDocumentCheckIcon' as const,
      })) || []),
      ...(languages?.map(({ key, label, level }) => ({
        key,
        label: `${label} - ${level}`,
        icon: 'FlagIcon' as const,
      })) || []),
    ];

    return <PrimaryList itemList={itemList} type="default" />;
  }
);

OtherRequirementsPreview.displayName = 'OtherRequirementsPreview';
